import React, { createContext, useContext, useEffect, useState } from 'react'
import { Table } from 'semantic-ui-react'
import styles from './facility-view.module.css'
import FacilityActions from './facility-actions'
import IntelMsg from '../../ItelMsg'

export const FacilityViewContext = createContext()

const FacilityView = () => {
  const [tableBody, setTableBody] = useState()
  const { setViewFacility, facilityData } = useContext(FacilityViewContext)
  useEffect(() => {
    if (facilityData) {
      console.log(facilityData)
      setTableBody(buildRows(facilityData))
    }
  }, [facilityData])
  const goBack = () => {
    setViewFacility(false)
  }
  return (
    <div>
      <div className={styles.container}>
        <IntelMsg id="facilityDetails" />
      </div>
      <Table definition>
        <Table.Body>{tableBody}</Table.Body>
      </Table>

      <FacilityActions
        onBackClick={() => {
          goBack()
        }}
      />
    </div>
  )
}

const getCustomerRow = (label, value) => (
  <Table.Row>
    <Table.Cell width={3}>{label}</Table.Cell>
    <Table.Cell>{value}</Table.Cell>
  </Table.Row>
)

const buildRows = (facilityData) => {
  const rows = []
  Object.keys(facilityData).forEach(function (key) {
    if (Array.isArray(facilityData[key])) {
      facilityData[key].forEach((facilitiesObject) => {
        Object.keys(facilitiesObject).forEach((k) => {
          rows.push(
            getCustomerRow(<IntelMsg id={k} />, `${facilitiesObject[k]}`) ||
              'N/A',
          )
        })
      })
    } else {
      Object.keys(facilityData[key]).forEach((k) => {
        rows.push(
          getCustomerRow(<IntelMsg id={k} />, `${facilityData[key][k]}`) ||
            'N/A',
        )
      })
    }
  })

  return rows
}
export default FacilityView
